<template>
  <v-card>
    <v-card-title>Notes</v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-sheet
            color="transparent"
            class="d-flex"
            :class="[false ? 'flex-row-reverse' : 'flex-row']"
          >
            <!-- <div>
                <v-avatar size="40px" color="grey lighten-4">
                  <v-icon>people</v-icon>
                  <img :src="thread.user.avatar" :alt="thread.user.name" />
                </v-avatar>
              </div> -->
            <note-form :clientId="clientId" :elevation="1" @updated="refresh" />
          </v-sheet>
        </v-col>
      </v-row>

      <v-row v-for="(entry, i) in dateItems" :key="i">
        <v-col cols="12">
          <v-sheet
            color="transparent"
            class="d-flex"
            :class="[false ? 'flex-row-reverse' : 'flex-row']"
          >
            <!-- <div>
                <v-avatar size="40px" color="grey lighten-4">
                  <v-icon>people</v-icon>
                </v-avatar>
              </div> -->
            <v-card
              class="elevation-1"
              :class="false ? 'neu-glow-inset rounded' : 'rounded'"
              style="width: 100%"
            >
              <v-card-subtitle class="d-flex">
                <div>
                  <Avatar
                    :firstName="entry.authorFirstName"
                    lastName="entry.authorLastName"
                  />
                  Created at {{ entry.dateCreated | formatDatetime }}
                </div>
                <v-spacer />

                <v-chip color="info" class="mr-2" small label>{{
                  entry.channel
                }}</v-chip>

                <v-chip
                  v-if="entry.isCompleted"
                  color="success"
                  class="mr-2"
                  small
                  label
                  ><v-icon>check</v-icon> Done</v-chip
                >
                <v-btn
                  v-else
                  @click="onMarkDone(entry)"
                  color="success"
                  class="mr-2"
                  min-height="23"
                  x-small
                  ><v-icon>check</v-icon> Mark As Done</v-btn
                >
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn icon small class="content-ma-0" v-on="on">
                      <v-icon small>mdi-cogs</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="onEdit(entry)">
                      <v-list-item-title>
                        <v-icon small left>mdi-pencil</v-icon>Edit
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="onDelete(entry)">
                      <v-list-item-title>
                        <v-icon small left>delete</v-icon>Delete
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-subtitle>
              <v-card-text>
                <div
                  style="white-space: pre-line"
                  v-html="entry.notes"
                  v-if="selectedItem.id !== entry.id"
                ></div>
                <note-form
                  @updated="refresh"
                  :value="entry"
                  :clientId="clientId"
                  v-else
                  :elevation="0"
                  @cancel="onCancelEdit(entry)"
                />
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <div class="text-center" v-if="totalPage >1">
            <v-pagination v-model="page" :length="totalPage" :total-visible="5" />
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <DeleteDialog
      :item="deletedItem"
      :show="showDeleted"
      @onClosed="clearDelete()"
      @onSucceded="refresh()"
    />
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import NoteForm from "../Notes/Form";
import DeleteDialog from "../Notes/_Delete";
import Avatar from "components/Avatar";
import formatterMixin from "@/mixins/formatterMixin";

export default {
  mixins: [formatterMixin],
  props: {
    item: Object,
    clientId: Number,
  },

  components: {
    NoteForm,
    DeleteDialog,
    Avatar,
  },

  data() {
    return {
      doneLoading: false,
      selectedItem: {},
      deletedItem: {},
      showDeleted: false,
      page: 1,
      pageSize: 20, //default 20
      //when task to get total rows doen, just modify theis line below

    };
  },

  methods: {
    ...mapActions({
      getAll: "notes/getAll",
      noteUpdate: "notes/update",
    }),

    onEdit(entry) {
      this.selectedItem = { ...entry };
    },

    clearDelete() {
      this.deletedItem = {};
      this.showDeleted = false;
    },

    onDelete(entry) {
      this.deletedItem = { ...entry };
      this.showDeleted = true;
    },

    async onMarkDone(entry) {
      let payload = {
        ...entry,
        isCompleted: true,
      };
      entry.loading = true;
      await this.noteUpdate(payload);
      await this.refresh();
      entry.loading = false;
    },

    onCancelEdit() {
      this.selectedItem = {};
    },

    async refresh() {
      await this.getAll({
        ...this.computedFilter
      });
    },
  },

  watch: {
    async page() {
      await this.refresh();
    }
  },

  async created() {
    await this.refresh();
  },

  computed: {
    ...mapGetters({
      entries: "notes/getAll",
    }),

    ...mapState({
      totalItems: (state) => state.notes.metaData.totalEntries
    }),

    totalPage()  {
      return Math.ceil(this.totalItems/this.pageSize);
    },
    computedFilter() {
      let params = {
        PageNumber: this.page ? this.page : 1,
        PageSize: this.pageSize,
        clientId: this.clientId
      };
      
      return params;
    },    

    dateItems() {
      return this.entries
        .filter((entry) => entry.clientId === this.clientId)
        .map((entry) => {
          return {
            ...entry,
            editMode: false,
            loading: false,
          };
        })
        .reverse();
    },
  },
};
</script>